/* eslint-disable */
module.exports = {
    "en": {
        "total-win": "TOTAL WIN",
        "win-more-than": "Win more than {0} your bet",
        "you-won-fs": "You won {0} free spins",
        "info2": "Collect at least 3 scatters to win 15 free spins",
        "info3": "xSplits - Any symbol in a hi-lighted position is split in and upto 4 Ways",
        "info4": "Collect 3 special wilds to trigger re-spins with 3 wilds randomly placed on the panel.",
        "info5": "Win big with 4 xSplits, guaranteed wilds per spin and wild collection and placements in free spins!",
        "freespinsInfo": "Special Wild collect and release,  x4 Way multipliers per symbol, guaranteed wilds per spin, and unlimited free spins till you collect all special Wilds!",
        "info-wild": "This symbol is a Wild",
        "info-specialwild": "This symbol is a special Wild",
        "allwaysContent": "With All Ways, there are no fixed pay lines - symbols just need to land on adjacent reels to generate wins. Wins per way are calculated based on the longest combination from left to right."
    }
}
